<template>
    <div class="single-answer" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
        <div class="q-privew">
            <div class="q-number" v-if="currentQuestion.questionNo">Q {{currentQuestion.questionNo}}</div>
            <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">Suggestions {{currentQuestion.suggestions}} </div>
            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
            <div class="pyq-tag-section" v-if="showPyqButton" style="margin-top: 10px; white-space: nowrap;">
                <div
                    v-for="(tag, index) in pyqTags"
                    :key="index"
                    class="pyq-card"
                    style="display: inline-block; margin-right: 8px;"
                >
                    <div class="pyq-btn" style="background-color: #039be5; color: white; padding: 6px 16px; border-radius: 4px; border: 1px solid #039be5; min-width: 60px; text-align: center;">
                        {{ tag }}
                    </div>
                </div>
            </div>
        </div>

        <div class="question-part" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div v-for="(opt,opIndex) in currentQuestion.options" 
                :key="opIndex" class="que-row" 
                :class="{'selected-option' : isQPchecked(opt, currentQuestion.correctAnswer) }">
                <div class="que-col-1">
                    <span class="opction-text">{{opt.index}}</span>
                    <div class="check-cust">
                        <div class="private-radio" v-if="showAnswerField">
                            <input
                                type="checkbox"
                                :checked="isChecked(opt)"
                                :disabled="currentQuestion.disabled"
                                @change="onChangeInput($event,opt)"
                                :id="opt.id"
                            />
                            <i
                                v-if="isChecked(opt)"
                                aria-hidden="true"
                                class="v-icon mdi mdi-checkbox-marked theme--light"
                                :class="{'green--text' : isQPchecked(opt,currentQuestion.correctAnswer) && !currentQuestion.isAttemptingTest, 'red--text' : !isQPchecked(opt,currentQuestion.correctAnswer) && !currentQuestion.isAttemptingTest, 'blue--text' : currentQuestion.isAttemptingTest}"                                
                            ></i>
                            <i
                                v-else
                                aria-hidden="true"
                                class="v-icon mdi mdi-checkbox-blank-outline theme--light"
                            ></i>
                        </div>
                    </div>
                </div>
                <div class="que-col-2">
                  <label :for="opt.id">  
                      <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)"   :class="{'option-font':!optionFont(opt)}" v-html="opt.option_text"></div>
                  </label>
                </div>
            </div>
        </div>
        <div class="test-solution">
            <div v-if="isPastTest">
                <!-- ansStatus: {{currentQuestion.ansStatus}} -->
                <div>
                    <v-row>
                        <v-col cols="5"><label class="ans-text-3may">Your Answer:</label>{{currentQuestion.yourAnswer}}
                            <span v-if="currentQuestion.isBonus">
                                ({{ BONUS_MESSAGE }})
                            </span>
                        </v-col>
                        <v-col cols="6"><label class="ans-text-3may">Correct Answer: </label>{{currentQuestion.correctAnswer}}</v-col>
                        
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
                    <v-row
                        v-if="currentQuestion.solutionVideos && currentQuestion.solutionVideos.length"
                        @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)"
                    >
                        <v-col cols="12">Video Solution:</v-col>
                        <v-col
                            cols="10"
                            v-for="video in currentQuestion.solutionVideos"
                            :key="video.id"
                        >
                            <div>
                                <video height="100" width="150" controls>
                                    <source :src="video.video_url" />
                                </video>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
                        <v-col cols="9" sm="11">
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-if="(currentQuestion.solution&&currentQuestion.isPreview&& currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
            <div v-else-if="(currentQuestion.solution&&currentQuestion.isPreview) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "MultipleCorrect",
    props: ["currentQuestion", "showAnswerField","openMandatoryQuePopup", "practiceSessionView"],
    data() {
        return {};
    },
    mounted() {
        this.renderMath();
    },
    computed: {
        ...mapGetters("testStore", ["isPastTest"]),
        ...mapState("userStore", ["user", "myInstitute"]),
        showPyqButton() {
            return (
                this.myInstitute?.id === constants.ONLINE_INSTITUTE_ID &&
                this.user?.role_code === 'ST' &&
                this.currentQuestion?.question_tags &&
                this.pyqTags.length > 0
            );
        },
        pyqTags() {
            if (!this.currentQuestion?.question_tags) return [];
            const tags = this.currentQuestion.question_tags.split(',');
            return tags
                .filter(tag => tag.includes('PYQ_'))
                .map(tag => tag.replace('PYQ_', '').trim());
        }
    },
    methods: {
        ...mapActions({
            setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
        }),
        onChangeInput(e, opt) {
            if(this.currentQuestion.isAnswerDisabled === true){
                if(this.practiceSessionView!==true){
                    this.openMandatoryQuePopup();
                }
            }else{
                opt.correct_answer = e.target.checked;
                this.$forceUpdate();
                this.checkIfAnswered();
                this.setDisableSecondaryAction(true);
            }     
        },
        isQPchecked(opt,correct_answer) {
            if(this.currentQuestion.isPreview && !this.currentQuestion.isShowSolution) {
               return this.isChecked(opt); 
            }
            else {
                return this.isCorrect(opt, correct_answer);
            }
        },
        checkIfAnswered() {
            var isAnswered = false;
            this.currentQuestion.options.forEach((option) => {
                if (option.correct_answer == true) {
                    isAnswered = true;
                }
            });
            this.currentQuestion.isAnswered = isAnswered;
            // if (this.currentQuestion.parent_id) {
            //     this.$parent.currentQuestion.isAnswered = isAnswered;
            // } else {
            //     this.currentQuestion.isAnswered = isAnswered;
            // }
        },
        rightClickDisable(e) {
            e.preventDefault();   
        },
    },
    watch: {
        "currentQuestion.id": function (val) {
            this.renderMath();
            this.renderMath();
        },
    },
};
</script>
